/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ValoreStoricoDTO { 
    tipo?: ValoreStoricoDTOTipoEnum;
    valore?: any | null;
}
export enum ValoreStoricoDTOTipoEnum {
    STRINGA = 'STRINGA',
    NUMERO = 'NUMERO',
    BOOLEANO = 'BOOLEANO',
    DATA = 'DATA',
    MULTI = 'MULTI'
};



